module.exports = __webpack_public_path__ + "src/assets/img/me.2bf3b02b.png";